import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraOverlayDialog, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';
import { ConvertToPreAwardDialog } from '../components/ProposalDashboard/ConvertToPreAwardDialog';
import { ProposalContextAdoption } from '../components/ProposalDashboard/ProposalContextAdoption';
import { ProposalContextReconciliation } from '../components/ProposalDashboard/ProposalContextReconciliation';
import { ProposalSubmissionPanel } from '../components/ProposalDashboard/Submission/ProposalSubmissionPanel';
import { ProposalRecordBreadcrumbs } from '../components/RecordShell/ProposalRecordBreadcrumbs';
import { useProposalRecordShellEnabled } from '../components/RecordShell/recordShellFlag';
import { useAuth } from '../contexts/authContext';
import { ProjectProvider, useProjectContext } from '../contexts/ProjectContext';
function ProposalSubmissions() {
    const { user } = useAuth();
    const { project, projectId, role, isLoading, error } = useProjectContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const sourceSubmission = searchParams.get('submission');
    const [open, setOpen] = useState(false);
    const historyOpen = open || !!sourceSubmission;
    function setHistoryOpen(next) {
        setOpen(next);
        if (!next && sourceSubmission) setSearchParams((previous)=>{
            const params = new URLSearchParams(previous);
            params.delete('submission');
            return params;
        }, {
            replace: true
        });
    }
    const [handoffOpen, setHandoffOpen] = useState(false);
    if (!user?.tenant_id || !projectId || isLoading || error || project?.type !== 'proposal' || !role) return null;
    const account = JSON.stringify([
        user.tenant_id,
        user.id
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        className: "shrink-0",
        children: [
            /*#__PURE__*/ _jsx(SpecraButton, {
                "data-testid": Testids.proposalSubmission.open,
                variant: "outline",
                onClick: ()=>setOpen(true),
                children: "Submission history"
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "outline",
                "data-testid": Testids.proposalHandoff.open,
                onClick: ()=>setHandoffOpen(true),
                children: "Send to Pre-Award"
            }),
            /*#__PURE__*/ _jsx(ConvertToPreAwardDialog, {
                open: handoffOpen,
                onOpenChange: setHandoffOpen,
                project: project
            }),
            /*#__PURE__*/ _jsxs(SpecraOverlayDialog, {
                open: historyOpen,
                onOpenChange: setHistoryOpen,
                title: "Actual proposal submissions",
                size: "xl",
                testId: Testids.proposalSubmission.dialog,
                children: [
                    sourceSubmission && /*#__PURE__*/ _jsxs(SpecraText, {
                        className: "block",
                        children: [
                            "Source recorded submission: ",
                            sourceSubmission
                        ]
                    }),
                    historyOpen && /*#__PURE__*/ _jsx(ProposalSubmissionPanel, {
                        projectId: projectId,
                        account: account,
                        tenantId: user.tenant_id,
                        owner: role === 'owner'
                    }, JSON.stringify([
                        account,
                        projectId,
                        role
                    ]))
                ]
            })
        ]
    });
}
/**
 * Layout wrapper for all /proposal/:id/* routes.
 * Provides ProjectContext (using param "id" as projectId) to nested routes.
 */ export function ProposalLayout() {
    const { id } = useParams();
    const proposalShell = useProposalRecordShellEnabled();
    return /*#__PURE__*/ _jsx(ProjectProvider, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex h-full min-h-0 flex-col",
            children: [
                id && proposalShell ? /*#__PURE__*/ _jsx(ProposalRecordBreadcrumbs, {
                    projectId: id
                }) : null,
                id && /*#__PURE__*/ _jsx(ProposalContextAdoption, {
                    projectId: id
                }),
                /*#__PURE__*/ _jsx(ProposalSubmissions, {}),
                id && /*#__PURE__*/ _jsx(ProposalContextReconciliation, {
                    projectId: id
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "min-h-0 flex-1",
                    children: /*#__PURE__*/ _jsx(Outlet, {})
                })
            ]
        })
    });
}
